import {
  Button,
  ButtonVariants,
  Flex,
  FormControlSizes,
  FormGroup,
  Grid,
  IconButton,
  IconName,
  NumberInput,
  Stack,
  toBigWithDefault,
} from '@talos/kyoko';
import { useCallback } from 'react';

export function SizeBucketSettings({
  value,
  onChange,
}: {
  value: string[];
  onChange: (sizeBuckets: string[]) => void;
}) {
  const handleBucketChange = useCallback(
    (index: number, newValue: string) => {
      const updatedBuckets = [...value];
      updatedBuckets[index] = newValue;
      onChange(updatedBuckets);
    },
    [value, onChange]
  );

  const handleAddBucket = useCallback(() => {
    const newValue = toBigWithDefault(value.slice(-1)?.[0], '1').times(2).toFixed();
    onChange([...value, newValue]);
  }, [onChange, value]);

  const handleRemoveBucket = useCallback(
    (index: number) => {
      const updatedBuckets = [...value];
      updatedBuckets.splice(index, 1);
      onChange(updatedBuckets);
    },
    [value, onChange]
  );

  return (
    <FormGroup label="Size Buckets">
      <Stack gap="spacing4" overflow="auto">
        {value.map((bucket, index) => (
          <Flex key={index} gap="spacing4">
            <NumberInput
              size={FormControlSizes.Small}
              value={bucket}
              min={value[index - 1]}
              max={value[index + 1]}
              onChange={value => handleBucketChange(index, value)}
            />
            {value.length > 1 ? (
              <IconButton
                size={FormControlSizes.Small}
                icon={IconName.Trash}
                onClick={() => handleRemoveBucket(index)}
                disabled={value.length <= 1}
              />
            ) : null}
          </Flex>
        ))}
      </Stack>
      <Grid gridTemplateColumns="minmax(92px, 0.3fr) 1fr" gap="spacing4" mt="spacing4">
        <Button size={FormControlSizes.Small}>Reset buckets</Button>
        <Button size={FormControlSizes.Small} variant={ButtonVariants.Positive} onClick={handleAddBucket}>
          Add bucket
        </Button>
      </Grid>
    </FormGroup>
  );
}
